import React from 'react'
import PropTypes from 'prop-types'
import {Link as RouterLink} from 'react-router-dom'
import {Box, Flex, Img, Text, useBreakpointValue, useMultiStyleConfig} from '@chakra-ui/react'
import CurrentPrice from '../../../display-price/current-price'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import useProductData from '../../../../hooks/use-product-data'
import OmnibusPrice from '../../../display-price/omnibus-price'

const ProductBox = ({product, styleVariant}) => {
    const styles = useMultiStyleConfig('ProductMoodboard', {variant: styleVariant})

    const viewType = useBreakpointValue({base: 'small', lg: 'medium'})

    const {locale} = useMultiSite()

    const images = product?.imageGroups?.find((group) => group.viewType == viewType)?.images
    const image = images && images?.length > 0 ? images[0] : {}

    const {priceData} = useProductData(product || {})
    return (
        <Flex
            data-testid="product-box"
            as={RouterLink}
            to={
                locale?.alias
                    ? `/${locale.alias}/p/${product?.id ? product?.id + '.html' : '#'}`
                    : '#'
            }
            {...styles.productbox}
        >
            <Box {...styles.imagecontainer} className={'img-container'}>
                <Img src={image?.link || ''} alt={image?.alt || ''} {...styles.image} />
                <Box {...styles.imageoverlay} />
            </Box>
            <Flex {...styles.textbox}>
                <Text {...styles.productId}>{product?.id || <>&nbsp;</>}</Text>
                <Text {...styles.productName}>{product?.c_variantIdentifier || <>&nbsp;</>}</Text>
                {product?.price && product?.currency ? (
                    <CurrentPrice
                        price={product?.price}
                        currency={product?.currency}
                        {...styles.price}
                    />
                ) : (
                    <Text {...styles.price}>&nbsp;</Text>
                )}
                <Flex {...styles.omnibusPrice}>
                    {(priceData?.showOmnibusPrice || priceData?.showOmnibusPriceDiscount) &&
                    product?.currency ? (
                        <OmnibusPrice
                            priceData={priceData}
                            currency={product?.currency}
                            omnibusExpandedView={false}
                            showDiscount={true}
                            variant={'recommended'}
                        />
                    ) : (
                        <>&nbsp;</>
                    )}
                </Flex>
            </Flex>
        </Flex>
    )
}

ProductBox.propTypes = {
    product: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        c_variantIdentifier: PropTypes.string,
        imageGroups: PropTypes.arrayOf(PropTypes.shape()),
        currency: PropTypes.string,
        price: PropTypes.number,
    }),
    styleVariant: PropTypes.string,
}

export default ProductBox
